import { Coupon } from '@dtx-company/true-common/src/types/Coupon'
import { Plan } from '@dtx-company/true-common/src/types/Plan'
import { promoAppliesToSelectedPlan } from '@dtx-company/app/shared/common/src/components/PlanPurchaseExperience/utils/promoAppliesToSelectedPlan'

/**
 * Return the discount percent as a number from 0 to 1 for a plan that has a promo code
 */
export const getDiscountPercentForPlanFromPromo = (promo: Partial<Coupon>, plan: Plan): number => {
  const planHasPromoCode = promoAppliesToSelectedPlan(promo, plan)
  // Plan has no promo
  if (!planHasPromoCode) return 0

  // Promo does not have percent off
  if (!promo.percentOff) return 0

  return promo.percentOff / 100
}
